import apiClient from '@/shared/api/client'
import type { Role, Permission, AssignPermissionsRequest } from '@/shared/types/rbac'

interface ListParams {
  page?: number
  page_size?: number
}

interface PaginatedResponse<T> {
  items: T[]
  total: number
  page: number
  page_size: number
}

export const rolesApi = {
  list: async (params?: ListParams): Promise<PaginatedResponse<Role>> => {
    const res = await apiClient.get<PaginatedResponse<Role>>('/roles', { params })
    return res.data
  },

  get: async (id: string): Promise<Role> => {
    const res = await apiClient.get<Role>(`/roles/${id}`)
    return res.data
  },

  create: async (data: { role_code: string; role_name: string; description?: string }): Promise<Role> => {
    const res = await apiClient.post<Role>('/roles', data)
    return res.data
  },

  listPermissions: async (): Promise<Permission[]> => {
    const res = await apiClient.get<Permission[]>('/permissions')
    return res.data
  },

  assignPermissions: async (id: string, data: AssignPermissionsRequest): Promise<Role> => {
    const res = await apiClient.put<Role>(`/roles/${id}/permissions`, data)
    return res.data
  },
}
